import React from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
import { hasAnalyticsConsent, isAdminPath, isAnalyticsEnabledByEnv } from '../../utils/analyticsConsent';
import { initializeAnalyticsIfAllowed } from '../../utils/analyticsInit';
import { trackMetaPageView } from '../../utils/metaPixel';

/**
 * AnalyticsRouter component
 * Router-level component that tracks pageviews and disables analytics for admin routes.
 * Also owns Meta Pixel PageView (landing + SPA navigations) so Meta is not init-only.
 */
const AnalyticsRouter = () => {
  const location = useLocation();
  const { pathname, search } = location;

  // Effect runs on route change
  React.useEffect(() => {
    // Meta PageView is marketing-gated inside trackMetaPageView (not analytics consent).
    trackMetaPageView(pathname);

    if (!isAnalyticsEnabledByEnv()) return;

    // An existing tag may have deferred Ads setup while the visitor was on admin.
    initializeAnalyticsIfAllowed();

    if (!hasAnalyticsConsent() || !ReactGA.isInitialized) {
      return;
    }

    // Check if current route is an admin route
    const isAdminRoute = isAdminPath(pathname);

    if (isAdminRoute) {
      // If on admin route, disable tracking by setting send_page_view to false
      ReactGA.set({ 'send_page_view': false });
    } else {
      // Enable tracking for non-admin routes
      ReactGA.set({ 'send_page_view': true });
      
      // Send pageview for non-admin routes
      ReactGA.send({ 
        hitType: "pageview", 
        page: pathname + search 
      });
    }
  }, [pathname, search]); // Re-run when route changes

  // This component doesn't render anything
  return null;
};

export default AnalyticsRouter;
